import React from 'react'
import './index.scss'
export class TagInput extends React.Component {
  constructor (props) {
    super(props)

    // eslint-disable-next-line react/state-in-constructor
    this.state = {
      items: this.props.defaultValue || [],
      focused: false,
      input: '',
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this)
    this.handleRemoveItem = this.handleRemoveItem.bind(this)
  }

  render () {
    return (
      <div className='inputHach'>
        {this.state.items.map((item, i) =>
          <div key={i} className='inputItem' onClick={this.handleRemoveItem(i)}>
            {item}
          </div>,
        )}
        <input
          className='inputHashCustom'
          value={this.state.input}
          onChange={this.handleInputChange}
          onKeyDown={this.handleInputKeyDown}
        />
      </div>
    )
  }

  handleInputChange (evt) {
    const value = evt.target.value.trim()

    if (this.state.items?.length < 4 && value?.length < 20) {
      this.setState({ input: `#${value?.split('#')?.join('')}` })
      this.props.setLastValue(`#${value?.split('#')?.join('')}`)
      this.props.setOpenAlert(false)
    } else if (value?.length) {
      this.props.setOpenAlert('Maximum 4 hashtags and 20 characters!')
    }
  }

  handleInputKeyDown (evt) {
    if (evt.key === 'Backspace') {
      if (this.state.input === '#') {
        this.setState({ input: '' })
      }
    }
    if (evt.key === ' ' || evt.key === 'Spacebar') {
      const { value } = evt.target
      if (value?.length) {
        const newItems = [...this.state.items, value]
        this.setState({
          items: newItems,
          input: '',
        })
        this.props.onChangeValue(newItems)
      }
    }

    if (this.state.items.length && evt.keyCode === 8 && !this.state.input.length) {
      const newItems = this.state.items.slice(0, this.state.items.length - 1)
      this.setState({
        items: newItems,
      })
      this.props.onChangeValue(newItems)
    }
  }

  handleRemoveItem (index) {
    return () => {
      this.setState(state => ({
        items: state.items.filter((item, i) => i !== index),
      }))
      this.props.onChangeValue(this.state.items)
    }
  }
}
